import React, { Component, Fragment, Suspense } from "react";
import "./Header.scss";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { isDevelopment } from "../../../utils/env";
import {
  isBDCLoggedIn,
  isClientLoggedIn,
  isPgmLoggedIn,
} from "../../../utils/DeApi";
import moment from "moment";
import { getToken, setToken } from "../../../utils/AuthService";
import bdcUserContext from "../../contextServices/bdcUserContext";

class Header extends Component {
  static contextType = bdcUserContext;
  
  constructor(props) {
    super(props);
    this.state = {
      filedAt:
        localStorage.getItem("filedAt") !== undefined &&
        localStorage.getItem("filedAt") !== null
          ? localStorage.getItem("filedAt")
          : moment().format("YYYY-MM-DD"),
    };
  }

  render() {
    let user = this.props.user || "";
    let title = this.props.title || "";
    let isPgmUser = isPgmLoggedIn();
    const { match } = this.props;
    const { sensePGMUser, unSensePGMUser } = this.context;
    const selectedApp = isPgmUser ? "LeadsModule" : "DealSense";
    const pgmUser = getToken("is_pgm_user") || "n";

    return (
      <Fragment>
        <HelmetProvider>
          <Suspense fallback={null}>
            <Helmet>
              <meta charSet="utf-8" />
              <title>{"Deal Sense - " + title}</title>
            </Helmet>
          </Suspense>
        </HelmetProvider>
        <Navbar
          className="border-bottom fixed-top MainHeader bg-white"
          expand="lg"
        >
          <Container>
            <Navbar.Brand as={Link} to={isPgmUser ? "/leadsmodule" : "/"}>
              <span className="logo">
                <strong>{isPgmUser ? "LeadsModule" : "DealSense"}</strong>
              </span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ml-auto">
                {isBDCLoggedIn() && !isClientLoggedIn() && !isPgmLoggedIn() ? (
                  <Nav.Link
                    as={Link}
                    active={match.path === "/form-types"}
                    to="/form-types"
                  >
                    Forms
                  </Nav.Link>
                ) : null}
                {/* adding keyword list route (below)  */}
                {isDevelopment() &&
                !isBDCLoggedIn() &&
                !isClientLoggedIn() &&
                !isPgmLoggedIn() ? (
                  <Nav.Link
                    as={Link}
                    active={match.path === "/keyword-types"}
                    to="/keyword-types"
                  >
                    Keywords
                  </Nav.Link>
                ) : null}
                {isDevelopment() &&
                !isBDCLoggedIn() &&
                !isClientLoggedIn() &&
                isPgmLoggedIn() ? (
                  <Nav.Link
                    as={Link}
                    active={match.path === "/leadsmodule/keyword-types"}
                    to="/leadsmodule/keyword-types"
                  >
                    Keywords
                  </Nav.Link>
                ) : null}
                {isBDCLoggedIn() && !isClientLoggedIn() && !isPgmLoggedIn() ? (
                  <Nav.Link
                    as={Link}
                    active={match.path === "/ciks"}
                    to="/ciks"
                  >
                    CIKS
                  </Nav.Link>
                ) : null}
                {/* {( !isBDCLoggedIn() && !isClientLoggedIn() ) ? (<Nav.Link as={Link} active={match.path === "/search"} to="/search">Search</Nav.Link>) : null} */}
                {/* {( !isBDCLoggedIn() && !isClientLoggedIn() ) ? (<Nav.Link as={Link} active={match.path === "/selections"} to="/selections">Selections</Nav.Link>) : null} */}
                {!isBDCLoggedIn() && !isClientLoggedIn() && !isPgmLoggedIn() ? (
                  <Nav.Link
                    as={Link}
                    active={match.path === `/selections/show`}
                    to={`selections/show`}
                  >
                    Selections
                  </Nav.Link>
                ) : null}

                {/* {( !isBDCLoggedIn() && !isClientLoggedIn() ) ? (<Nav.Link as={Link} active={match.path === "/catalogues"} to="/catalogues">Catalogues</Nav.Link>) : null} */}
                {!isBDCLoggedIn() && !isClientLoggedIn() && !isPgmLoggedIn() ? (
                  <Nav.Link
                    as={Link}
                    active={match.path === "/client"}
                    to="/client"
                  >
                    Client
                  </Nav.Link>
                ) : null}
                {!isBDCLoggedIn() && !isClientLoggedIn() && !isPgmLoggedIn() ? (
                  <Nav.Link
                    as={Link}
                    active={match.path === "/optimizedSearch"}
                    to="/optimizedSearch"
                  >
                    FullText Search
                  </Nav.Link>
                ) : null}
                {!isBDCLoggedIn() && !isClientLoggedIn() && isPgmLoggedIn() ? (
                  <Nav.Link
                    as={Link}
                    active={match.path === "/leadsmodule/optimizedSearch"}
                    to="/leadsmodule/optimizedSearch"
                  >
                    FullText Search
                  </Nav.Link>
                ) : null}
                {/* <NavDropdown title={<span className="material-icons">account_circle</span>} alignRight={true} id="collasible-nav-dropdown" caret="false"> */}
                {/* {( !isBDCLoggedIn() ) ? (<Nav.Link as={Link} active={match.path === "/catalogues"} disabled to="javascript:void(0)">|</Nav.Link>) : null} */}
                <NavDropdown
                  title={"| Hi, " + user.firstName}
                  alignRight={true}
                  id="collasible-nav-dropdown"
                  caret="false"
                >
                  <NavDropdown.Header disabled>{user.email}</NavDropdown.Header>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/logout">
                    <span className="material-icons">logout</span>
                    &nbsp;&nbsp;Logout{" "}
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </Fragment>
    );
  }
}

Header.propTypes = {
  user: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default withRouter(Header);
